import * as React from 'react';
import LoadingBars from '@reverbdotcom/commons/dist/components/loading_bars';
import ThreeDS1Container, { IProps as Threeds1Props } from './threeds1_container';

export default class CheckoutThreeDS1Container extends React.Component<Threeds1Props, null> {
  render() {
    return (
      <div>
        <div className="d-flex fx-justify-center mtb-1">
          <LoadingBars />
        </div>
        <ThreeDS1Container
          show3ds1AlertBox={false}
          {...this.props}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_threeds1_container.tsx